export default {"src":"/_next/static/media/avatar.84943bf6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};